<template>
	<div class="k-component -duty">
		<b-container>
			<b-row align-h="center">
				<b-col col lg="8" class="text-center">
					<h1 v-if="dutyData.title" v-html="dutyData.title"></h1>
					<h2 v-if="dutyData.subtitle">{{ dutyData.subtitle }}</h2>
					<div v-if="dutyData.description" v-html="dutyData.description"></div>
					<hr class="my-5" />
				</b-col>
			</b-row>
		</b-container>
		<b-container>
			<b-row>
				<DutyItem v-for="itemData in dutyData.items" :key="itemData.id" :item-data="itemData" />
			</b-row>
		</b-container>
	</div>
</template>

<script>
import DutyItem from '@/components/DutyItem.vue'

export default {
	name: 'Duty',

	components: {
		DutyItem
	},

	props: {
		dutyData: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/scss/_component-duty.scss';
</style>
